<template>
  <div>
    <div class="content" v-if="dataStudioLink == null">
      <b-row class="justify-content-center my-5">
        <div class="col-10 col-sm-6 col-md-4 col-lg-3 text-center">
          <img
            src="@/assets/images/capa_1.png"
            alt="Whoops!"
            class="text-center img-fluid"
            style="border: none"
          />
        </div>
      </b-row>
      <b-row class="justify-content-center">
        <b-col lg="6" md="6">
          <h3 class="text-center font-weight-bold">
            Good things take time!
          </h3>
          <h5 class="text-center">
            We're still working on creating a better<br/>
            experience for you. Come back soon to see<br/>
            your customized dashboard.
          </h5>
        </b-col>
      </b-row>
    </div>
    <div class="content-body customers-wrapper transaction-history" v-else>
      <div class="col-10 col-sm-12 col-md-12 col-lg-12">
        <iframe
          title="eStore Analytics Data"
          width="600"
          height="450"
          :src="dataStudioLink"
          style="border: 0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DataStudio",
  computed: {
    ...mapState("dataStudio", ["dataStudioLink"]),
  },
  async created() {
    await this.$store.dispatch("dataStudio/fetchDataStudioLink");
    this.$nextTick(() => {
      if (
        this.dataStudioLink.substring(0, 30) !==
          "https://datastudio.google.com/" &&
        this.dataStudioLink.substring(0, 32) !==
          "https://lookerstudio.google.com/"
      ) {
        this.$store.commit("dataStudio/setDataStudioLink", null);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
iframe {
  display: block;
  width: 100%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
}
.rush-logo {
  width: 80px;
}
.page-not-found {
  margin-top: 100px;
}
.page-not-found-notice {
  font-family: MainFontRegular, sans-serif;
  color: #828898;
  font-size: 18px;
}
.back-to-dashboard {
  width: 162.78px;
  display: block;
  border-radius: 20px;
  font-size: 14px;
}
h3.font-weight-bold {
  color: #FF6B00;
}
</style>
